import { ChevronLeftIcon, ChevronRightIcon } from '../../Icons';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { Box } from '../../Box';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const styledScrollButton = (direction, theme) => ({
  cursor: 'pointer',
  position: 'absolute',
  boxShadow: `0 0 4px ${theme.tokens.SemColorShadowMuted}`,
  borderRadius: '9999px',
  height: '32px',
  width: '32px',
  background: theme.tokens.SemColorSurfaceDefault,
  display: 'flex',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  ':hover': {
    background: theme.tokens.SemColorSurfaceInteractiveHover
  },
  zIndex: '1000',
  ...(direction === 'left' ? {
    left: '0',
    marginLeft: '4px'
  } : {
    right: 0,
    marginRight: '4px'
  }),
  transform: 'translateY(25%)'
});
export const TabScrollButton = props => {
  const theme = useInterstateTheme();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: !props.disabled && /*#__PURE__*/_jsx(Box, {
      sx: styledScrollButton(props.direction, theme),
      onClick: props.onClick,
      children: props.direction === 'left' ? /*#__PURE__*/_jsx(ChevronLeftIcon, {
        color: theme.tokens.SemColorOnSurfaceButtonSecondaryRest
      }) : /*#__PURE__*/_jsx(ChevronRightIcon, {
        color: theme.tokens.SemColorOnSurfaceButtonSecondaryRest
      })
    })
  });
};